import { convertDateToMomentDateObjAtMidnightInSellerTimeZone } from '../../../../../services/datetime-service';

/*
// The V3 backend expects a DateTime in UTC that corresponds to
// the start of day (midnight, 00:00:00) in the seller's time zone.
// for both the "startDate" and "endDate" so that it may apply the
// offset from UTC to then query with these adjusted start/end DateTimes.
//
// ** Example **
// To support a seller in Jamaica (UTC-5) who requests a report for 1/4/2025,
// we should do the following conversion:
//    Seller TZ (Jamaica)             UTC (UTC)
//  1/4/2025 00:00:00 UTC-5  -->  1/4/2025 05:00:00 UTC
//
// This is complicated by the fact that *the browser* will determine the time zone value
// of the Date object created by the user's selection. So if our Jamaican seller uses
// a machine in "Arizona/Phoenix" (UTC-7), the created Date will be "1/4/2025 00:00:00 UTC-7"
//
// Because of this we coerce — rather than convert — the intial Date into the seller's timezone:
//     Browser TZ (Arizona)         Seller TZ (Jamaica)            UTC (UTC)
//  1/4/2025 00:00:00 UTC-7  -->  1/4/2025 00:00:00 UTC-5  -->  1/4/2025 05:00:00 UTC
//
// (DT 3/23/22)
*/

export const generateReportReadyDateTimeAsISOString = (dateValue, sellerTimeZone) => {
  const sellerStartOfDayInSellerTimeZone = convertDateToMomentDateObjAtMidnightInSellerTimeZone(dateValue, sellerTimeZone);
  const sellerStartOfDayInUtc = sellerStartOfDayInSellerTimeZone.toISOString();

  return sellerStartOfDayInUtc;
};
